import { isInBrowser } from '../utils/isInBrowser.js';
import { defalutSpmId, variableTypeDetection, deepMerge } from '../utils/unils.js';
import { options } from './option.js';
import pkg from '../../package.json.js';
import { startRequestTracking } from '../track/index.js';
import { addIntoReportPool, changeReporterOfReportPool } from './reportPool.js';
import { getDejavuVersionData } from '../utils/dejavuVersion.js';
import { useReporter } from '@bilibili/cross-scripts';

const DEJAVU_VERSION_INFO = getDejavuVersionData();
const taskQueue = [];
let isPending = false;
let isUserOtherInstanceName = '';
let reportMiddlewareIns_ = null; //中间件上报实例
// 统一处理mirror上报eventId字段,用于技术和业务上报
const getMirrorProject = (options$1) => {
    // 优先级 字配置 otherSpmId> 全配置spmId > 页面spm_id
    let project = '';
    if (options$1.diyevent) {
        project = options$1.eventId || options$1.event;
    }
    else {
        project = options$1.otherSpmId
            ? `${options$1.otherSpmId}.${options$1.eventId}`
            : (options === null || options === void 0 ? void 0 : options.spmId)
                ? `${options === null || options === void 0 ? void 0 : options.spmId}.${options$1.eventId}`
                : `${defalutSpmId}.${options$1.eventId}`;
    }
    return project;
};
// 执行promise任务队列
function performWorkIfNeeded() {
    if (taskQueue.length && !isPending) {
        isPending = true;
        const [task, reportFn, params, options] = taskQueue.shift();
        if (reportFn === 'middleWare') {
            // 中间件消载入处理
            if (reportMiddlewareIns_) {
                isPending = false;
                _techReportPbForMiddleWare(params, options);
                performWorkIfNeeded();
                return;
            }
            else {
                task(true).then(res => {
                    isPending = false;
                    reportMiddlewareIns_ = res;
                    changeReporterOfReportPool(reportMiddlewareIns_);
                    _realTechReportMiddleware(params, options);
                    performWorkIfNeeded();
                });
            }
        }
        else {
            // 正常Load任务
            task().then(() => {
                isPending = false;
                // 存在fn和参数再执行上报,--对应initloadReport只需要window注册
                if (reportFn && params) {
                    reportFn(params, options || undefined);
                }
                performWorkIfNeeded();
            });
        }
    }
}
// 业务上报
const _realCustomReport = (options) => {
    const report = isUserOtherInstanceName ? window[isUserOtherInstanceName] : window.__biliMirrorPbInstance__;
    // 优先级 字配置 otherSpmId> 全配置spmId > 页面spm_id
    options = transformReportParams(options);
    const projectString = getMirrorProject(options);
    report === null || report === void 0 ? void 0 : report[options.type](projectString, options.msg);
};
// 技术上报
const _realTechReport = (options, newOptions) => {
    // init or 修改配置
    if (newOptions && Object.keys(newOptions).length > 0) {
        changeReport(newOptions);
    }
    options = transformReportParams(options);
    const projectString = getMirrorProject(options);
    const report = isUserOtherInstanceName ? window[isUserOtherInstanceName] : window.__biliMirrorPbInstance__;
    const realMsg = Object.assign(Object.assign(Object.assign({}, options.msg), DEJAVU_VERSION_INFO), { mirrorVersion: pkg.version, type: options.type || 'custom' });
    report === null || report === void 0 ? void 0 : report['tech'](projectString, realMsg);
};
// 业务上报对外入口-任务队列
const reportCustomPb = (options) => {
    taskQueue.push([loadPbReport, _realCustomReport, options]);
    performWorkIfNeeded();
};
// 技术上报对外入口-任务队列
const _techReportPb = (options, newOptions) => {
    taskQueue.push([loadPbReport, _realTechReport, options, newOptions]);
    performWorkIfNeeded();
};
// 中间件 & 接口上报,batch会存在延迟上报操作
const _techReportPbForMiddleWare = (options, config) => {
    // 用户track上报相关api
    startRequestTracking(options.msg);
    // 兼容下 msg到message字段,外部历史bug兼容
    if (!options.msg.message && options.msg.msg) {
        options.msg.message = options.msg.msg;
    }
    if (reportMiddlewareIns_) {
        _realTechReportMiddleware(options, config);
    }
    else {
        taskQueue.push([loadPbReport, 'middleWare', options, config]);
        performWorkIfNeeded();
    }
};
const _realTechReportMiddleware = (options$1, config) => {
    if (!config || (config === null || config === void 0 ? void 0 : config.isBatch) === undefined) {
        config = Object.assign(config || {}, { isBatch: false });
    }
    const EVENT_ID_SUCCESS = '.DATA.successReport';
    const EVENT_ID_ERROR = '.ERROR.errorReport';
    const EVENT_ID_BEFORE = ((config === null || config === void 0 ? void 0 : config.spmId) || defalutSpmId) +
        '.' +
        ((config === null || config === void 0 ? void 0 : config.origin) || (options === null || options === void 0 ? void 0 : options.origin)) +
        '.' +
        ((config === null || config === void 0 ? void 0 : config.module) || (options === null || options === void 0 ? void 0 : options.module));
    // 是否延迟聚合或者命中白名单
    if (config === null || config === void 0 ? void 0 : config.isBatch) {
        addIntoReportPool(EVENT_ID_BEFORE + (config.eventId || EVENT_ID_SUCCESS), options$1.msg, Object.assign({ type: 'custom', mirrorVersion: pkg.version }, DEJAVU_VERSION_INFO));
    }
    else {
        reportMiddlewareIns_['tech'](EVENT_ID_BEFORE + (config.eventId || EVENT_ID_ERROR), Object.assign(Object.assign({ type: options$1.type || 'custom', mirrorVersion: pkg.version }, options$1.msg), DEJAVU_VERSION_INFO));
    }
};
// 修改配置
const changeReport = (params = { feature: { tech: true } }) => {
    const defaultOptions = {
        feature: { tech: true }
    };
    window.__biliMirrorPbInstance__.options = Object.assign(defaultOptions, params);
};
// 加载pb脚本
const loadPbReport = (isMiddleWare = false) => {
    try {
        return new Promise((resolve, reject) => {
            if (!isInBrowser())
                reject('not support in server');
            // 如果是单独实例,上报中间件单独使用
            if (isMiddleWare) {
                const defaultOptions = {
                    feature: { tech: true },
                    autoPv: false,
                    batch: false
                };
                // 如果有引入pb-js,直接new 新实例
                if (window.ReporterPb) {
                    const ins_ = new window.ReporterPb(Object.assign({}, defaultOptions));
                    resolve(ins_);
                }
                else {
                    // 没有加载过pb脚本
                    useReporter(Object.assign({}, defaultOptions)).then(ins => {
                        const ins_ = ins;
                        resolve(ins_);
                    });
                }
            }
            else {
                // 针对使用了pb-report又引入了mirror,会优先使用使用方的单例来上报
                const key = (options === null || options === void 0 ? void 0 : options.pbOtherNameIns) ? options === null || options === void 0 ? void 0 : options.pbOtherNameIns : '';
                if (variableTypeDetection.isObject(window[key]) && Object.keys(window[key]).length) {
                    isUserOtherInstanceName = key;
                    console.warn(`Is using ${key} to report,Please confirm open [tech] config`);
                    resolve();
                }
                else if (window.__biliMirrorPbInstance__) {
                    resolve();
                }
                else {
                    const defaultOptions = {
                        feature: { tech: true },
                        extra: Object.assign(Object.assign({}, DEJAVU_VERSION_INFO), { mirrorVersion: pkg.version })
                    };
                    // 深度合并pb配置
                    const reportPbOptions = deepMerge(defaultOptions, (options === null || options === void 0 ? void 0 : options.pbOptions) || {});
                    // 如果载入过pb脚本
                    if (window.ReporterPb) {
                        window.__biliMirrorPbInstance__ = new window.ReporterPb(reportPbOptions);
                        resolve();
                    }
                    else {
                        // 没有加载过pb脚本
                        useReporter(Object.assign({}, reportPbOptions)).then(ins => {
                            window.__biliMirrorPbInstance__ = ins;
                            resolve();
                        });
                    }
                }
            }
        });
    }
    catch (error) {
        console.error('bili-mirror:load pb-report-Error load failed:', error);
    }
};
// 兼容磨平meta-report上报和pb上报字段的差异，方便外部业务方替换
function transformReportParams(data) {
    if (data.event && !data.eventId) {
        data.eventId = data.event;
    }
    // 磨平event_id只有一段导致最终上报只有3段式不符合规范的差异
    const eventIdLength = data.eventId.split('.').length;
    if (eventIdLength <= 1) {
        data.eventId = `${options === null || options === void 0 ? void 0 : options.origin}.${options === null || options === void 0 ? void 0 : options.module}.${data.eventId}`;
    }
    data.type === 'appear' ? (data.type = 'exposure') : null;
    return data;
}

export { _techReportPb, _techReportPbForMiddleWare, changeReport, loadPbReport, reportCustomPb };
